"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var next_intl_1 = require("next-intl");
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var PaymentsBanner = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.fullHeight, fullHeight = _c === void 0 ? false : _c;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var bannerConfig = (0, swr_hooks_1.usePromoBannerConfig)(swr_hooks_1.TEXT_KEYS.PAYMENTS_BANNER);
    var isMobile = Object.keys(breakpoints).length > 0 && breakpoints.mobile;
    var containerStyle = (0, swr_hooks_1.getPromoBannerBackgroundStyle)(bannerConfig, isMobile);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(fullHeight ? styles_module_scss_1.default.fullHeight : ''), style: containerStyle },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.titleContainer },
            react_1.default.createElement("h1", { className: styles_module_scss_1.default.title }, title || t('payments')))));
};
exports.default = PaymentsBanner;
